<companyid-title-with-social-media
    title="Terms and Conditions"
    i18n-title="@@terms-and-conditions-title"
    i18n-subtitle="@@terms-and-conditions-subtitle"
    subtitle="Please read these terms and conditions carefully before using Our Service." />
<companyid-text-block-with-side-bar [contentItems]="termsAndConditionTexts" />
